/** @format */

import React, { Component } from 'react';
import ClientsToolbar from './ClientsToolbar/ClientsToolbar';
import { Table, Icon, Loader, Dimmer } from 'semantic-ui-react';
import { getDateFromTimestamp } from '../../helpers/getDateFromTimestamp';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import AdvanceClientSearch from './AdvanceClientSearch/AdvanceClientSearch';

import _ from 'lodash';
import './Clients.css';

@inject('ClientsStore')
@observer
class Clients extends Component {
  renderTableHeader = () => {
    let { ClientsStore } = this.props;
    let renderTableHeader = null;
    let tableKeys = ClientsStore.clientsParams.tableKeys;
    renderTableHeader = tableKeys.map(key => {
      return (
        <Table.HeaderCell
          className="table-head-cell"
          onClick={() => ClientsStore.sortClientsBy(key)}
          key={key}
        >
          {key}
        </Table.HeaderCell>
      );
    });
    return <Table.Row key="">{renderTableHeader}</Table.Row>;
  };

  renderContent = content => {
    if (content !== undefined && content !== null && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  renderTableBody = () => {
    let renderTableBody = null;
    let { ClientsStore } = this.props;
    let clients = ClientsStore.clients;
    if (
      clients !== undefined &&
      clients !== null &&
      Object.keys(clients).length > 0
    ) {
      let clientsValues = Object.values(clients);
      let searchValue = ClientsStore.clientsParams.searchValue;

      ClientsStore.assignKey();

      let sortedClientsValues = _.orderBy(
        clientsValues,
        ['data.' + ClientsStore.clientsParams.orderBy.prop],
        [ClientsStore.clientsParams.orderBy.direction],
      );

      if (searchValue !== '') {
        sortedClientsValues.forEach((client, index) => {
          const clientName = client.data.name + ' ' + client.data.surname;
          if (clientName.toLowerCase().indexOf(searchValue.toLowerCase()) < 0) {
            delete sortedClientsValues[index];
          }
        });
      }
      if (clientsValues.length !== 0) {
        renderTableBody = sortedClientsValues.map(value => {
          const key = value.data.key;
          const clientName = value.data.name + ' ' + value.data.surname;
          return (
            <Table.Row
              key={key}
              onClick={() =>
                this.props.history.push('/clients/' + key + '/view')
              }
            >
              <Table.Cell>
                {clientName
                  .toLowerCase()
                  .split(' ')
                  .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(' ')}
              </Table.Cell>
              <Table.Cell>{this.renderContent(value.data.mobPhone)}</Table.Cell>
              <Table.Cell>{this.renderContent(value.data.email)}</Table.Cell>
              <Table.Cell>{value.data.salesNum}</Table.Cell>
              <Table.Cell>{value.data.salesValue}€</Table.Cell>
              <Table.Cell>
                {getDateFromTimestamp(value.data.timestamp)}
              </Table.Cell>
            </Table.Row>
          );
        });
      } else {
        renderTableBody = (
          <Table.Row>
            <Table.Cell
              colSpan="6"
              className="table-preloader"
              textAlign="center"
            >
              <Dimmer inverted active>
                <Loader size="small" inverted />
              </Dimmer>
            </Table.Cell>
          </Table.Row>
        );
      }
    }
    return renderTableBody;
  };

  render() {
    let { ClientsStore } = this.props;
    return (
      <div>
        <ClientsToolbar
          searchClient={value => ClientsStore.searchClient(value)}
        />
        <AdvanceClientSearch />
        <Table sortable size="small" selectable className="app-manage-table">
          <Table.Header className="table-head">
            {this.renderTableHeader()}
          </Table.Header>
          <Table.Body>
            {this.renderTableBody()}
            <Table.Row
              className="clickable"
              onClick={() => ClientsStore.loadMoreClients()}
            >
              <Table.Cell colSpan={6} textAlign="center">
                <Icon name="download" />
                <strong>Scarica più Clienti</strong>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default withRouter(Clients);
